import { useMemo } from 'react'
import { Link } from 'react-router'
import styled from 'styled-components'

import { UserShortAvatar } from '@root/entities/user-short/ui/user-short-avatar'
import { ProfileRoute } from '@root/features/routing/model'

import type { UserMinimal } from '@root/entities/user-short/model'

type TradeMakerCellOwnerProps = {
  owner: UserMinimal.UserMinimal
}

export const TradeMakerCellOwner: React.FC<TradeMakerCellOwnerProps> = ({
  owner,
}) => {
  const username = useMemo(() => {
    if (owner.username.length > 7) {
      return owner.username.slice(0, 7) + '…'
    }
    return owner.username
  }, [owner.username])

  const profileUrl = useMemo(() => {
    return ProfileRoute.build({ delugeId: owner.delugeId })
  }, [owner.delugeId])

  return (
    <Root as={Link} to={profileUrl}>
      <UserShortAvatar userShort={owner} size={14} />
      <Label>{username}</Label>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 4px;

  color: inherit;
  &:link,
  &:visited {
    color: inherit;
  }
  font-family: ${({ theme }) => theme.fontFamily};
`

const Label = styled.div``
